import React, { useContext } from 'react';
import styled from 'styled-components';
import { SvgSprite } from 'modules/svgSprite';
import { useSpring, animated } from '@react-spring/web';
import { ItemContext } from './accordionItem';

export const AccordionItemArrowElement = styled(SvgSprite)<{ isExpanded: boolean }>`
    flex: none;
    width: 16px;
    height: 16px;
    margin-left: 10px;
`;
const AnimatedAccordionItemArrowElement = animated<any>(AccordionItemArrowElement);

export default function AccordionItemArrow(props): JSX.Element {
    const { isExpanded } = useContext(ItemContext);
    const spring = useSpring({
        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
        config: { tension: 250 }
    });

    return <AnimatedAccordionItemArrowElement sprite="Arrow" isExpanded={isExpanded} style={spring} {...props} />;
}
